import { Component, Input } from '@angular/core';
import { ConstantHelper } from '@veritas-shared/helpers/constant.helper';
import { FooterConfigDto } from '@veritas-shared/models/footer.model';

@Component({
  selector: 'app-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss']
})
export class ModalFooterComponent {
  // !!IMPORTANT!!
  // To avoid problems onSave and onCancel need arrow function to work
  @Input() public onSave: () => void = () => {};
  @Input() public onCancel: () => void = () => {};
  @Input() public config?: FooterConfigDto;

  constructor(
    public constantHelper: ConstantHelper
  ){}
}
